export const decodeCookie = (cname) => {
  const name = `${cname}`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

export const logOut = (redirect = null) => {
  window.localStorage.clear();
  document.cookie =
    process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_TOKEN_KEY +
    "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  document.cookie =
    process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_USER_DATA +
    "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  document.cookie = "tripbuilder=; max-age=0; domain=tripmerchant.com; path=/;";

  window.location.replace(
    process.env.REACT_APP_ENV === "local"
    ? `http://localhost:3000/login?logout=-${redirect ? `&redirect=${redirect}` : ""}`
    : `${process.env.REACT_APP_TRIP_MERCHANT_COM_URL}login?logout=-${redirect ? `&redirect=${redirect}` : ""}`
  );
};